const DEFAULT_LOGO_PATHS = [
    /\/example_project_images\/logo-wall\/logo-[^/]+$/i,
    /\/example_project_images\/logo-[^/]+$/i,
];

function stripQueryAndHash(url) {
    return url.split(/[?#]/)[0];
}

export function isDefaultLogoWallLogo(url) {
    if (!url) return false;
    return DEFAULT_LOGO_PATHS.some(pattern => pattern.test(stripQueryAndHash(url)));
}

export function getWhiteLogoWallLogoUrl(url) {
    if (!url || /-white\.[^/.?#]+([?#].*)?$/i.test(url)) return url;
    return url.replace(/(\.[^/.?#]+)([?#].*)?$/i, "-white$1$2");
}

export function resolveLogoWallLogoUrl(logo, isDarkMode, fallbackUrl = null) {
    if (isDarkMode && isDefaultLogoWallLogo(logo?.url)) {
        return getWhiteLogoWallLogoUrl(logo.url);
    }

    return logo?.croppedImageUrl || logo?.url || fallbackUrl;
}
